module.exports = __webpack_public_path__ + "img/service-and-shop-filter-hyundai.829a8c85.jpg";